module.exports = __webpack_public_path__ + "assets/uka.068a0e4ee6ea1820034f45045496f9e1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/home/uka.jpg
 ** module id = 348
 ** module chunks = 0
 **/